import React from 'react';
import {ConstraintDataPlugin, ConstraintPluginProps} from '../ConstraintDataPlugin';
import {
    ConstraintType,
    DataTypeConstraintDto,
    EnumerationConstraintDataDto
} from '../../../../../../common/apis/datatype/DataTypeConstraintDto';
import {CoreDataType} from "../../../../../../common/apis/datatype/DataTypeDefinitionDto";
import {EnumerationConstraintPluginForm} from "./EnumerationConstraintPluginForm";
import {DataTypeTranslationKey} from "../../DataTypeTranslationKey";
import {t, TranslationFunction} from "../../../../../../store/localization/TranslMessasge";
import {ConstraintValueValidationPlugin} from "../ConstraintValueValidationPlugin";


export class EnumerationConstraintPlugin implements ConstraintDataPlugin<EnumerationConstraintDataDto>, ConstraintValueValidationPlugin {
    readonly type = ConstraintType.ENUMERATION;

    getSupportedDataTypes(): CoreDataType[] {
        return [
            CoreDataType.STRING, CoreDataType.INTEGER, CoreDataType.FLOAT, CoreDataType.CURRENCY
        ];
    }

    getInitialData(): EnumerationConstraintDataDto {
        return {
            type: ConstraintType.ENUMERATION,
            values: []
        };
    }

    render(props: ConstraintPluginProps<EnumerationConstraintDataDto>): React.ReactElement {
        return <EnumerationConstraintPluginForm {...props} />;
    }

    validate(data: EnumerationConstraintDataDto, coreDataType: CoreDataType): Record<string, string> {
        const errors: Record<string, string> = {};

        if (!data.values || data.values.length === 0) {
            errors.values = t(DataTypeTranslationKey.AT_LEAST_ONE_ENUM_VALUE_IS_REQUIRED);
        }

        return errors;
    }

    getConstraintExpression(data: EnumerationConstraintDataDto): string {
        return data.values?.join(", ") || "";
    }

    validateValue(value: any, attributeId: string, constraint: DataTypeConstraintDto, t: TranslationFunction): Record<string, string> {
        // TODO: will be implemented as a part of the following task AR-2057
        return {};
    }

}
